import React, { useState, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import MobileCTABar from "@/components/MobileCTABar";
import WishlistDrawer from "@/components/WishlistDrawer";
import SampleRequestModal from "@/components/SampleRequestModal";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import TypePage from "@/pages/TypePage";
import LotPage from "@/pages/LotPage";
import ThankYou from "@/pages/ThankYou";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Placeholder from "@/pages/Placeholder";
import AdminUpload from "@/pages/AdminUpload";

import { WishlistProvider, WishlistContext } from "@/context/WishlistContext";
import { SampleRequestProvider } from "@/context/SampleRequestContext";

function AppContent() {
  const [wishlistOpen, setWishlistOpen] = useState(false);
  const { wishlistCount } = useContext(WishlistContext);
  const location = useLocation();

  // Check if we're on a Lot page (hide generic mobile CTA)
  const isLotPage = location.pathname.match(/^\/collection\/[^/]+\/lot\/[^/]+$/);

  // Admin tool is a standalone page - no navbar/footer/modals/customer chrome
  const isAdminPage = location.pathname.startsWith("/admin");
  if (isAdminPage) {
    return (
      <Routes>
        <Route path="/admin/upload" element={<AdminUpload />} />
      </Routes>
    );
  }

  return (
    <div className="App min-h-screen bg-brand-charcoal text-brand-cream antialiased">
      <ScrollToTop />
      <Navbar
        onOpenWishlist={() => setWishlistOpen(true)}
        wishlistCount={wishlistCount}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/collection" element={<Collection />} />
        <Route path="/collection/:slug" element={<TypePage />} />
        <Route path="/collection/:slug/lot/:lotId" element={<LotPage />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/how-it-works" element={<Placeholder title="How It Works" />} />
        <Route path="/about" element={<Placeholder title="About" />} />
        <Route path="/contact" element={<Placeholder title="Contact" />} />
        <Route path="/request-samples" element={<Placeholder title="Request Samples" />} />
        <Route path="*" element={<Placeholder title="Not Found" />} />
      </Routes>

      <Footer />

      <WhatsAppButton />
      {!isLotPage && <MobileCTABar />}
      <WishlistDrawer
        open={wishlistOpen}
        onOpenChange={setWishlistOpen}
      />
      <SampleRequestModal />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <WishlistProvider>
        <SampleRequestProvider>
          <AppContent />
        </SampleRequestProvider>
      </WishlistProvider>
    </BrowserRouter>
  );
}

export default App;
